import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { fetchAuthSession } from '@aws-amplify/auth';
import ReactMarkdown from 'react-markdown';
import '../styles/markdown.css';
import SERVICE_API_URL from '../serviceUrl';

const WeeklyTip = () => {
  const [tips, setTips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLatestTips = async () => {
      const session = await fetchAuthSession();
      const idToken = session.tokens?.idToken?.toString();

      try {
        const response = await axios.get(`${SERVICE_API_URL}/prep/tips/latest`, {
          headers: {
            'Authorization': `Bearer ${idToken}`
          }
        });
        setTips(Array.isArray(response.data) ? response.data : [response.data]);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch the latest tips');
        setLoading(false);
      }
    };

    fetchLatestTips();
  }, []);

  if (loading) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: 'var(--spacing-lg)' }}>
        <p>Loading weekly tips...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: 'var(--spacing-lg)' }}>
        <p style={{ color: 'var(--error)' }}>{error}</p>
      </div>
    );
  }

  if (!tips.length) {
    return null;
  }

  return (
    <div className="card" style={{ 
      backgroundColor: 'white',
      padding: 'var(--spacing-lg)',
      marginBottom: 'var(--spacing-2xl)',
      border: '1px solid var(--border)',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
    }}>
      <div style={{ 
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--spacing-xl)'
      }}>
        {tips.map((tip, index) => (
          <div key={index} style={{ 
            display: 'flex',
            alignItems: 'flex-start',
            gap: 'var(--spacing-md)'
          }}>
            <div style={{ 
              backgroundColor: 'var(--primary-light)',
              borderRadius: '50%',
              padding: 'var(--spacing-md)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'var(--primary-color)'
            }}>
              <span style={{ fontSize: '24px' }}>💡</span>
            </div>
            <div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--spacing-sm)',
                marginBottom: 'var(--spacing-sm)'
              }}>
                <h3 style={{ 
                  margin: 0,
                  fontSize: 'var(--font-size-lg)',
                  color: 'var(--text-primary)'
                }}>
                  Weekly Tip {tips.length > 1 ? `#${index + 1}` : ''}
                </h3>
                <span className="badge" style={{ 
                  backgroundColor: 'var(--primary-color)',
                  color: 'white',
                  padding: '2px 8px',
                  borderRadius: 'var(--radius-sm)',
                  fontSize: 'var(--font-size-sm)'
                }}>
                  {tip.category}
                </span>
              </div>
              <div className="markdown-content" style={{ 
                color: 'var(--text-secondary)',
                lineHeight: 1.6,
                fontSize: 'var(--font-size-md)'
              }}>
                <ReactMarkdown>{tip.message}</ReactMarkdown>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeeklyTip; 